// extracted by mini-css-extract-plugin
module.exports = {"container":"PostEventCard_container__1T094","close":"PostEventCard_close__1RcKV","title":"PostEventCard_title__24kQN","subtitle":"PostEventCard_subtitle__xEBFI"};